import React, { useState } from "react";
import Ornament from "@/components/Ornament";
import Reveal from "@/components/Reveal";
import MapModal from "@/components/MapModal";

const TIMELINE = [
  { time: "1 pm", text: "Wedding ceremony at St Peter & St Paul's Church" },
  { time: "Afternoon", text: "Drinks, dinner & toasts at Foxhill Manor" },
  { time: "7 pm", text: "Evening celebration begins — music, dancing & celebrations" },
  { time: "1 am", text: "Carriages" },
];

const OurDay = () => {
  const [map, setMap] = useState(null);

  return (
    <section id="day" className="section day" data-testid="section-day">
      <Ornament />
      <Reveal as="h2" className="script-h2">
        Our Day
      </Reveal>

      <div className="cards two">
        <Reveal className="card" delay={0}>
          <h4>Ceremony</h4>
          <p className="card-venue">St Peter &amp; St Paul&apos;s Church</p>
          <p className="card-address">Blockley</p>
          <p className="card-address">GL56 9DE</p>
          <p className="card-note">Service at 1 pm</p>
          <button
            className="textlink"
            onClick={() =>
              setMap({
                title: "St Peter & St Paul's Church",
                query: "St Peter and St Paul's Church, Blockley, GL56 9DE",
              })
            }
            data-testid="map-ceremony"
          >
            View map →
          </button>
        </Reveal>

        <Reveal className="card" delay={120}>
          <h4>Reception</h4>
          <p className="card-venue">Foxhill Manor</p>
          <p className="card-address">Farncombe, Broadway</p>
          <p className="card-address">WR12 7LJ</p>
          <p className="card-note">Following the ceremony</p>
          <button
            className="textlink"
            onClick={() =>
              setMap({
                title: "Foxhill Manor",
                query: "Foxhill Manor, Farncombe, Broadway, WR12 7LJ",
              })
            }
            data-testid="map-reception"
          >
            View map →
          </button>
        </Reveal>
      </div>

      <Reveal as="h3" className="small-caps timeline-title">
        The Order of the Day
      </Reveal>

      <ul className="timeline">
        {TIMELINE.map((t, i) => (
          <Reveal as="li" key={t.time} delay={i * 80}>
            <span className="t">{t.time}</span>
            <span className="dash">—</span>
            <span className="desc">{t.text}</span>
          </Reveal>
        ))}
      </ul>

      <Reveal as="p" className="muted center">
        An adults-only celebration.
      </Reveal>

      <MapModal
        open={!!map}
        onClose={() => setMap(null)}
        title={map?.title}
        query={map?.query}
      />
    </section>
  );
};

export default OurDay;
